import { __decorate, __extends } from "tslib";
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import CouponCountdown from './coupon-countdown.vue';
var CouponSlider = /** @class */ (function (_super) {
    __extends(CouponSlider, _super);
    function CouponSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonCopyDisplay = false;
        _this.buttonCopySuccessDisplay = false;
        _this.moduleContainerExpanded = false;
        _this.sliderContentDisplay = false;
        _this.showSlider = false;
        return _this;
    }
    CouponSlider.prototype.mounted = function () {
        this.closingTimeout = setTimeout(this.closeSlider, 5000);
    };
    Object.defineProperty(CouponSlider.prototype, "visited", {
        get: function () {
            return window.sessionStorage.getItem('visited-once') === 'true';
        },
        enumerable: false,
        configurable: true
    });
    CouponSlider.prototype.closeCouponLayer = function () {
        this.moduleContainerExpanded = false;
        this.sliderContentDisplay = false;
    };
    CouponSlider.prototype.copyToClipboard = function () {
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            var hiddenInput = this.$refs.hiddenInput;
            var editable = hiddenInput.contentEditable;
            var readOnly = hiddenInput.readOnly;
            hiddenInput.contentEditable = true;
            hiddenInput.readOnly = true;
            var range = document.createRange();
            range.selectNodeContents(hiddenInput);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            hiddenInput.setSelectionRange(0, 999999);
            hiddenInput.contentEditable = editable;
            hiddenInput.readOnly = readOnly;
            document.execCommand('copy');
        }
        else {
            //@ts-ignore
            navigator.clipboard.writeText(this.couponCode);
        }
        //@ts-ignore
        window.dataLayer = window.dataLayer || [];
        //@ts-ignore
        window.dataLayer.push({
            'event': 'CouponGenerator',
            'eventCategory': 'CouponGenerator',
            'eventAction': 'copy',
            'eventLabel': this.couponCode
        });
    };
    CouponSlider.prototype.copyClick = function () {
        this.copyToClipboard();
        this.buttonCopyDisplay = false;
        this.buttonCopySuccessDisplay = true;
        clearTimeout(this.closingTimeout);
        this.closingTimeout = setTimeout(this.closeSlider, 1000);
    };
    CouponSlider.prototype.closeSlider = function () {
        clearTimeout(this.closingTimeout);
        window.sessionStorage.setItem('visited-once', 'true');
        this.moduleContainerExpanded = false;
        this.sliderContentDisplay = false;
        //@ts-ignore
        window.dataLayer = window.dataLayer || [];
        //@ts-ignore
        window.dataLayer.push({
            'event': 'CouponGenerator',
            'eventCategory': 'CouponGenerator',
            'eventAction': 'closed',
            'eventLabel': this.couponCode
        });
    };
    CouponSlider.prototype.openSlider = function () {
        clearTimeout(this.closingTimeout);
        this.buttonCopyDisplay = true;
        this.buttonCopySuccessDisplay = false;
        this.moduleContainerExpanded = true;
        this.sliderContentDisplay = true;
        //@ts-ignore
        window.dataLayer = window.dataLayer || [];
        //@ts-ignore
        window.dataLayer.push({
            'event': 'CouponGenerator',
            'eventCategory': 'CouponGenerator',
            'eventAction': 'open',
            'eventLabel': this.couponCode
        });
    };
    CouponSlider.prototype.expandSlider = function () {
        if (this.moduleContainerExpanded) {
            this.closeSlider();
        }
        else {
            this.openSlider();
        }
    };
    Object.defineProperty(CouponSlider.prototype, "moduleContainerClassList", {
        get: function () {
            return 'lturCouponSliderModuleContainer lturCouponSlider-hide-close-button' + (this.moduleContainerExpanded ? ' expanded' : '');
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ default: false })
    ], CouponSlider.prototype, "showSlider", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "claim", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "codeLabel", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "countDown", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "couponCode", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "deadline", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "language", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "linkLabel", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "linkUrl", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "longTitle", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "subClaim", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "terms", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "labelCopyCode", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "labelCopyCodeSuccess", void 0);
    __decorate([
        Prop()
    ], CouponSlider.prototype, "labelCountdownHeadline", void 0);
    CouponSlider = __decorate([
        Component({
            components: {
                'coupon-countdown': CouponCountdown
            }
        })
    ], CouponSlider);
    return CouponSlider;
}(Vue));
export default CouponSlider;
